import api from "api";
import { supportApiBase } from "api/constants";
import { useQuery } from "react-query";
import { isUsMarket } from "utils/market";
import { queryKeys } from "utils/misc";
import { TemplateDto } from "./templateDtos";

export const useGetTemplate = (id?: number) =>
  useQuery<TemplateDto>(
    queryKeys.template(id ?? 0),
    async () => {
      const path = `GET /treatments/schedules/${id}?locale=${isUsMarket ? "en-US" : "sv-SE"}`;
      // @ts-ignore — v2 endpoint, not in OpenAPI types
      const data: TemplateDto = await api.parse(path, { root: supportApiBase });
      return data;
    },
    { enabled: !!id }
  );
